var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgQArrowDownRed = function SvgQArrowDownRed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#FFF3EF",
    rx: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F53428",
    d: "m10.702 11.588 2.306-2.093.992.884L10 14l-4-3.62.974-.886 2.306 2.094V6h1.422z"
  })));
};
export { SvgQArrowDownRed as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3Qgd2lkdGg9IjIwIiBoZWlnaHQ9IjIwIiByeD0iNCIgZmlsbD0iI0ZGRjNFRiIvPgo8cGF0aCBkPSJNMTAuNzAyIDExLjU4NzlMMTMuMDA3NiA5LjQ5NDUxTDE0IDEwLjM3OTFMMTAgMTRMNiAxMC4zNzkxTDYuOTc0MjggOS40OTQ1TDkuMjc5ODggMTEuNTg3OUw5LjI3OTg4IDZMMTAuNzAyIDZMMTAuNzAyIDExLjU4NzlaIiBmaWxsPSIjRjUzNDI4Ii8+Cjwvc3ZnPgo=";